import(/* webpackMode: "eager" */ "/app/app/events-offers/page.js");
